import { TextInput, UrlInput } from "djinn-components";
import { Controller } from "react-hook-form";
import { useSiteState } from "../../../../utils/useSiteState";
import FormHolder from "../../../../components/Form/FormHolder";
import Form from "../../../../components/Form";
import FormFieldErrors from "../../../../components/Form/FormFieldErrors";
import CustomDomainConfig from "../../../../components/CustomDomainConfig";
import { createDocsUrl } from "../../../../utils/urls";

const SiteSettingsUrlsPage = () => {
  const { site, reload } = useSiteState();

  const getDefaults = () => {
    const { subdomain, custom_domain } = site;

    return {
      subdomain,
      custom_domain,
    };
  };

  const onSubmit = async (responseData: any) => {
    // await fetchUser();
    await reload();
  };

  return (
    <>
      <title>Update Domain</title>

      <FormHolder>
        <Form
          getDefaults={getDefaults}
          onCompleted={onSubmit}
          buttonTitle="Save Settings"
          endpoint={`sites/${site.id}`}
          method="patch"
          className="w-2/3"
          render={({ errors, control, isDirty }) => (
            <>
              <h4 className="font-medium text-xl text-white mb-6">Settings</h4>

              <div className="mb-4 mt-6">
                <label className="mb-2 block ml-4 text-sm font-medium">
                  Subdomain
                </label>
                <Controller
                  name="subdomain"
                  control={control}
                  rules={{
                    required: false,
                  }}
                  render={({
                    field: { onChange, value },
                  }: any): JSX.Element => (
                    <UrlInput
                      value={value}
                      onChange={onChange}
                      invalid={!!errors.subdomain}
                      url={createDocsUrl()}
                    />
                  )}
                />

                <FormFieldErrors
                  errors={errors}
                  field="subdomain"
                  requiredMessage="Site subdomain is required"
                />
              </div>

              <div className="mb-4 mt-6">
                <label className="mb-2 block ml-4 text-sm font-medium">
                  Custom Domain
                </label>
                <Controller
                  name="custom_domain"
                  control={control}
                  rules={{
                    required: false,
                  }}
                  render={({
                    field: { onChange, value },
                  }: any): JSX.Element => (
                    <TextInput
                      value={value}
                      onChange={onChange}
                      invalid={!!errors.subdomain}
                      placeholder="Enter your custom domain"
                    />
                  )}
                />

                {site.custom_domain && !isDirty && <CustomDomainConfig />}

                <FormFieldErrors
                  errors={errors}
                  field="custom_domain"
                  requiredMessage="Site subdomain is required"
                />
              </div>
            </>
          )}
        />
      </FormHolder>
    </>
  );
};

export default SiteSettingsUrlsPage;
